import { jsx as e } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import m from "classnames";
import { memo as l } from "../../../external/preact/compat/dist/compat.module.js";
import { SKELETON_CLASS as i, SKELETON_LOADING as c, SKELETON_CONTAINER as S, STATUS_SKELETON as N } from "./constants.js";
const p = ({ skeletonRowNumber: o = 0 }) => {
  const t = m(i, c), a = Array.from({ length: o }), r = Array.from({ length: 2 });
  return /* @__PURE__ */ e("div", { className: S, children: [
    /* @__PURE__ */ e("div", { className: N, children: r.map((n, s) => /* @__PURE__ */ e("span", { className: t }, `status-skeleton-${s}`)) }),
    a.map((n, s) => /* @__PURE__ */ e("span", { className: t }, `skeleton-${s}`))
  ] });
}, k = l(p);
export {
  k as default
};
